import clsx from 'clsx'
import { AlertCircle } from 'lucide-react'
import { forwardRef } from 'react'
import type { FieldError } from 'react-hook-form'
import { InputErrorText } from '@/components/input-error-text'
import { Show } from '@/components/show'
import { Input, type InputProps } from '@/components/ui/input'

type TextInputProps = InputProps & {
  error?: FieldError
}

// eslint-disable-next-line react/display-name
export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ error, className, ...props }, ref) => {
    return (
      <div className="w-full">
        <div className="relative flex items-center w-full">
          <Input
            onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
              event.stopPropagation()
            }}
            ref={ref}
            className={clsx(
              'h-10',
              { 'border-destructive': !!error },
              className
            )}
            {...props}
          ></Input>
          <Show when={!!error}>
            <AlertCircle
              size={18}
              className="absolute text-destructive right-3"
            />
          </Show>
        </div>
        <InputErrorText error={error} />
      </div>
    )
  }
)
